import { useDispatch } from 'react-redux';

import { LogoutIcon } from 'shared/components/Icons';
import {
  removeOTPTokenFromLocalStorage,
  removeTokenFromLocalStorage
} from 'shared/utils/local-storage';
import { resetApp } from 'store/app/app.redux';
import { useTranslationCustom } from 'shared/utils/hooks/useTranslationCustom';
import { clearSentryUser } from 'shared/utils/sentry';

import classes from './styles.module.scss';

const Logout = () => {
  const t = useTranslationCustom();
  const dispatch = useDispatch();
  const handleLogout = () => {
    removeTokenFromLocalStorage();
    removeOTPTokenFromLocalStorage();
    clearSentryUser();
    dispatch(resetApp());
  };

  return (
    <button
      type="button"
      className={classes['header__icons__logout']}
      onClick={handleLogout}
      aria-label={t('login.logout', 'Logout')}
      title={t('login.logout', 'Logout')}
    >
      <LogoutIcon />
    </button>
  );
};

export default Logout;
